
import {
  defineComponent, onBeforeMount,
} from 'vue';
import { Modal } from 'ant-design-vue';
import { useRoute } from 'vue-router';
import router from '@/router';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useGradeBase } from '@/core/composables/GradeBase';
import { ETipoPermissao } from '@/models/Enumeradores/MeuSistema/Usuarios/ETipoPermissao';
import { ETipoTituloFinanceiro } from '@/models/Enumeradores/Financeiro/ETipoTituloFinanceiro';
import { IDTOTituloFinanceiro } from '@/models/DTO/Financeiro/TitulosFinanceiros/IDTOTituloFinanceiro';
import Icone from '@/core/components/Icone.vue';
import Card from '@/core/components/Tela/Card.vue';
import SelecionarData from '@/core/components/Tela/SelecionarData.vue';
import SelecionarCategoriaPlanoConta from '@/components/Cadastros/PlanosContas/SelecionarCategoriaPlanoConta.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import storeSistema from '@/store/storeSistema';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import SelecionarTipoValorFinanceiro from '@/components/Financeiro/SelecionarTipoValorFinanceiro.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import Totalizador from '@/core/components/Tela/Totalizador.vue';
import BuscarTitulosModal from '../../../components/Financeiro/TitulosFinanceiros/BuscarTitulosModal.vue';
import BaixaTitulosLancamento from '@/components/Financeiro/BaixaTitulosFinanceiros/BaixaTitulosLancamento.vue';
import { IDTOTituloFinanceiroPendenteBaixa } from '@/models/DTO/Financeiro/TitulosFinanceiros/IDTOTituloFinanceiroPendenteBaixa';
import RequisicaoModal from '@/core/components/Modal/RequisicaoModal.vue';
import { useModalBase } from '@/core/composables/ModalBase';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import BaixaTitulosLancamentoCarteira from '@/components/Financeiro/BaixaTitulosFinanceiros/BaixaTitulosLancamentoCarteira.vue';
import BaixaTitulosLancamentoCreditos from '@/components/Financeiro/BaixaTitulosFinanceiros/BaixaTitulosLancamentoCreditos.vue';
import BaixaTitulosUtilizacaoCredito from '@/components/Financeiro/BaixaTitulosFinanceiros/BaixaTitulosUtilizacaoCredito.vue';
import BaixaTitulosRepasse from '@/components/Financeiro/BaixaTitulosFinanceiros/BaixaTitulosRepasse.vue';
import SelecionarTituloFinanceiroPorNumero from '@/components/Financeiro/TitulosFinanceiros/SelecionarTituloFinanceiroPorNumero.vue';
import ServicoBaixaTitulosPagar from '@/servicos/Financeiro/ServicoBaixaTitulosPagar';
import ServicoParametros from '@/servicos/MeuSistema/ServicoParametros';
import UtilitarioFinanceiro from '@/core/utilitarios/UtilitarioFinanceiro';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IDTOLancamentoBaixaConta } from '@/models/DTO/Financeiro/BaixasTitulosFinanceiros/IDTOLancamentoBaixaConta';
import ServicoConta from '@/servicos/Cadastros/Financeiro/ServicoConta';
import { useBaixaTitulosBase } from '@/composables/Financeiro/BaixaTitulosBase';
import storeFinanceiro from '@/store/storeFinanceiro';
import { useFocusBase } from '@/core/composables/FocusBase';
import { IDTOComunicacaoFinanceiroStore } from '@/models/DTO/Financeiro/TitulosFinanceiros/IDTOComunicacaoFinanceiroStore';
import { IDTOTituloFinanceiroStore } from '@/models/DTO/Financeiro/TitulosFinanceiros/IDTOTituloStore';

export interface IAlertaBaixa {
  titulo: string;
  mensagem: string;
  tipo: string;
  visivel: boolean;
}
export default defineComponent({
  name: 'BaixaContasPagar',
  components: {
    Card,
    Icone,
    SelecionarData,
    MensagemSemDados,
    SelecionarTipoValorFinanceiro,
    SelecionarCategoriaPlanoConta,
    CampoNumerico,
    Totalizador,
    BuscarTitulosModal,
    BaixaTitulosLancamento,
    RequisicaoModal,
    BaixaTitulosLancamentoCarteira,
    BaixaTitulosUtilizacaoCredito,
    BaixaTitulosLancamentoCreditos,
    BaixaTitulosRepasse,
    SelecionarTituloFinanceiroPorNumero,
  },
  setup(props, { emit }) {
    const {
      telaBase, obterPermissoes, verificaAutorizacao, preencherEmpresasDisponiveis,
      adicionarAtalho, removerAtalho, apresentarMensagemSucesso,
    } = useTelaBase();
    const {
      gradeBase, ordenacaoAtiva,
    } = useGradeBase();
    const {
      modalBase, apresentarRetornoRequisicao, apresentarBarraProgresso, ocultarBarraProgresso,
    } = useModalBase(props, emit);

    const {
      focusBase, proximoElemento, elementoAnterior, elementoAcima, elementoAbaixo,
    } = useFocusBase();
    focusBase.classElementos = 'ss-baixa-contas-pagar-titulos-adicionados';

    const route = useRoute();
    const servicoBaixaTitulosPagar = new ServicoBaixaTitulosPagar();

    const servicoParametros = new ServicoParametros();
    const servicoSistema = new ServicoSistema();
    const servicoConta = new ServicoConta();
    servicoConta.requisicaoSistema();

    const {
      baixaTitulosBase, atualizarValorRestante, limparTelaBase, popularTitulosBaixa, calcularValores, prepararPreviaBaixa, obterDescricaoConta, obterDescricaoTipoMovimento, obterDescricaoInfluenciaSaldo, verificacaoCalculo, valorJurosMultaDigitado, valorAcrescimoDigitado, valorDescontoDigitado, verificacaoAlteracaoData, obterObjetoBaixa,
    } = useBaixaTitulosBase();
    baixaTitulosBase.identificadorRecurso = 'BAIXAS_CONTAS_PAGAR';
    baixaTitulosBase.identificadorPermissao = 'AUT_BAIXAS_CONTAS_PAGAR';
    baixaTitulosBase.tipoTituloBaixa = ETipoTituloFinanceiro.Pagar;
    gradeBase.layoutMobile = UtilitarioDispositivo.larguraTelaMobile();

    let listaTitulosSelecionados:IDTOTituloFinanceiro[] = [];
    let comunicacaoFinanceiro: IDTOComunicacaoFinanceiroStore = {} as IDTOComunicacaoFinanceiroStore;
    let storeTitulosFinanceiro: IDTOTituloFinanceiroStore = {} as IDTOTituloFinanceiroStore;

    function preencherColunas() {
      if (gradeBase.layoutMobile) {
        // Colunas - Títulos selecionados Baixa
        gradeBase.colunas = [
          {
            title: 'Código', dataIndex: 'codigoTituloFinanceiro', key: 'Codigo', position: 1, visible: false,
          },
          {
            title: 'Título', dataIndex: 'titulo', key: 'TituloFinanceiro', position: 2, visible: true,
          },
        ];

        // Colunas - Movimentos da Baixa
        baixaTitulosBase.colunasMovimentos = [
          {
            title: 'Movimento', dataIndex: 'movimento', key: 'MovimentoBaixa', position: 1, visible: true,
          },
        ];
      } else {
        // Colunas - Títulos selecionados Baixa
        gradeBase.colunas = [
          {
            title: 'Código', dataIndex: 'codigoTituloFinanceiro', key: 'Codigo', position: 1, visible: false,
          },
          {
            title: 'PGTO', dataIndex: 'tipoDocumentoFinanceiro', key: 'TipoDocumentoFinanceiro', position: 2, visible: true, width: 40, ellipsis: true, fixed: 'left',
          },
          {
            title: 'N.Identificação', dataIndex: 'numeroTitulo', key: 'NumeroTitulo', position: 3, visible: true, ellipsis: true, width: 75, fixed: 'left',
          },
          {
            title: 'Pessoa', dataIndex: 'nomePessoa', key: 'NomePessoa', position: 4, visible: true, ellipsis: true, width: 150, fixed: 'left',
          },
          {
            title: 'Vencimento', dataIndex: 'dataVencimento', key: 'DataVencimento', position: 5, visible: true, ordering: false, customRenderRow: ECustomRenderRow.MascararData, width: 60, align: 'center', fixed: 'left',
          },
          {
            title: 'Valor Título R$', dataIndex: 'saldo', key: 'Valor', position: 6, visible: true, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right', width: 75, fixed: 'left',
          },
          {
            title: 'Juros/Multa R$', dataIndex: 'ValorJurosMulta', key: 'ValorJurosMulta', position: 7, visible: true, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right', width: 75,
          },
          {
            title: 'Acréscimo R$', dataIndex: 'valorAcrescimo', key: 'ValorAcrescimo', position: 8, visible: true, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right', width: 70,
          },
          {
            title: 'Desconto R$', dataIndex: 'valorDesconto', key: 'ValorDesconto', position: 9, visible: true, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right', width: 65,
          },
          {
            title: 'Valor Total R$', dataIndex: 'valorTotal', key: 'ValorTotal', position: 10, visible: true, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right', width: 80,
          },
          {
            title: 'Conta', dataIndex: 'descricaoConta', key: 'Conta', position: 11, visible: true, ellipsis: true, width: 150,
          },
        ];
        // Colunas - Movimentos da Baixa
        baixaTitulosBase.colunasMovimentos = [
          {
            title: 'Conta', dataIndex: 'descricaoConta', key: 'Conta', position: 1, visible: true, ellipsis: true, width: 100,
          },
          {
            title: 'Data', dataIndex: 'dataMovimento', key: 'DataMovimento', position: 2, visible: true, ordering: false, customRenderRow: ECustomRenderRow.MascararData, width: 35, align: 'center',
          },
          {
            title: 'Tipo', dataIndex: 'descricaoTipoMovimento', key: 'DescricaoTipoMovimento', position: 3, visible: true, width: 40, ellipsis: true,
          },
          {
            title: 'Identificador', dataIndex: 'identificadorMovimento', key: 'IdentificadorMovimento', position: 4, visible: true, ellipsis: true, width: 75,
          },
          {
            title: 'Descrição', dataIndex: 'descricao', key: 'DescricaoMovimento', position: 5, visible: true, ellipsis: true, width: 90,
          },
          {
            title: 'Valor R$', dataIndex: 'valor', key: 'ValorMovimento', position: 6, visible: true, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right', width: 65,
          },
          {
            title: 'Influência Saldo', dataIndex: 'influenciaSaldo', key: 'InfluenciaSaldo', position: 7, visible: true, ordering: false, width: 40, align: 'center',
          },
        ];
      }
    }

    const mudarSelecao = (selectedRowKeys: any) => {
      gradeBase.codigosSelecionados = selectedRowKeys;
    };

    function limparTela() {
      limparTelaBase();
      gradeBase.codigosSelecionados = [] as number[];
    }

    async function obterValoresParametros() {
      baixaTitulosBase.carregandoParametros = true;

      const categoriaPadraoJurosMulta = await servicoParametros.obterValor(baixaTitulosBase.empresaSelecionada, 'PAR_FIN_PAGAR_CATEGORIA_PADRAO_JUROS_MULTA');
      if (categoriaPadraoJurosMulta !== undefined) {
        if (UtilitarioGeral.validaCodigo(categoriaPadraoJurosMulta.valor)) {
          baixaTitulosBase.categoriaPadraoJurosMulta = Number(categoriaPadraoJurosMulta.valor);
        }
      }

      const categoriaPadraoDescontos = await servicoParametros.obterValor(baixaTitulosBase.empresaSelecionada, 'PAR_FIN_PAGAR_CATEGORIA_PADRAO_DESCONTO');
      if (categoriaPadraoDescontos !== undefined) {
        if (UtilitarioGeral.validaCodigo(categoriaPadraoDescontos.valor)) {
          baixaTitulosBase.categoriaPadraoDesconto = Number(categoriaPadraoDescontos.valor);
        }
      }

      baixaTitulosBase.carregandoParametros = false;
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [] as number[];
      telaBase.empresasSelecionadas.push(baixaTitulosBase.empresaSelecionada);
      baixaTitulosBase.categoriaPadraoJurosMulta = 0;
      baixaTitulosBase.categoriaPadraoDesconto = 0;
      baixaTitulosBase.dataBaixa = await servicoSistema.obterDataAtual();
      baixaTitulosBase.contaPadrao = await servicoConta.obterCodigoContaPadrao(baixaTitulosBase.empresaSelecionada);
      limparTela();
      obterValoresParametros();
    }

    function preencherPessoaPadrao() {
      if (baixaTitulosBase.titulosBaixa.every((t) => t.codigoPessoa === baixaTitulosBase.titulosBaixa[0].codigoPessoa)) {
        baixaTitulosBase.pessoaPadrao = baixaTitulosBase.titulosBaixa[0].codigoPessoa;
      } else {
        baixaTitulosBase.pessoaPadrao = 0;
      }
    }

    function buscarTitulos() {
      baixaTitulosBase.exibirBuscaTitulos = true;
    }

    async function concluirBaixa() {
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };
      if (baixaTitulosBase.titulosBaixa.length === 0 && baixaTitulosBase.titulosRepassados.length === 0) {
        retorno.mensagem = 'Nenhum título selecionado para baixa!';
        retorno.status = EStatusRetornoRequisicao.Alerta;
        apresentarRetornoRequisicao(retorno);
        return;
      }

      apresentarBarraProgresso();
      const baixa = obterObjetoBaixa();

      retorno = await servicoBaixaTitulosPagar.baixarTitulos(baixa);
      ocultarBarraProgresso();
      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso(retorno.mensagem);
        limparTela();

        if (UtilitarioGeral.objetoValido(storeTitulosFinanceiro) && UtilitarioGeral.valorValido(storeTitulosFinanceiro.rotaRecursoOrigem)) {
          storeTitulosFinanceiro.token = UtilitarioGeral.gerarTokenUnico();
          storeTitulosFinanceiro.titulos = [];
          storeFinanceiro.mutations.adicionarTituloStore(storeTitulosFinanceiro);
          router.push({ name: storeTitulosFinanceiro.rotaRecursoOrigem, query: { token: storeTitulosFinanceiro.token } });
          return;
        }

        if (UtilitarioGeral.objetoValido(comunicacaoFinanceiro) && UtilitarioGeral.valorValido(comunicacaoFinanceiro.redirecionarAposConcluir)) {
          router.push({ name: comunicacaoFinanceiro.redirecionarAposConcluir, query: { token: comunicacaoFinanceiro.token } });
        }
      } else {
        apresentarRetornoRequisicao(retorno);
      }
    }

    function confirmacaoLimparTela() {
      Modal.confirm({
        title: 'Atenção',
        content: 'Tem certeza que deseja limpar a tela de baixa?',
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: () => {
          limparTela();
        },
      });
    }

    async function confirmacaoBaixa() {
      Modal.confirm({
        title: 'Concluir Baixa',
        content: 'Tem certeza que deseja concluir a baixa?',
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => {
          await concluirBaixa();
        },
      });
    }

    onBeforeMount(async () => {
      telaBase.carregando = true;
      telaBase.identificadorRecurso = baixaTitulosBase.identificadorRecurso;
      telaBase.identificadorPermissao = baixaTitulosBase.identificadorPermissao;
      baixaTitulosBase.empresaSelecionada = storeSistema.getters.codigoEmpresaOperacao();
      baixaTitulosBase.movimentosFinanceiros = [];
      baixaTitulosBase.lancamentosContaNormais = [];

      preencherColunas();
      const tokenStore = String(route.query.token);
      if (UtilitarioGeral.valorValido(tokenStore)) {
        listaTitulosSelecionados = storeFinanceiro.getters.obterTitulos(tokenStore);
        if (UtilitarioGeral.validaLista(listaTitulosSelecionados)) {
          baixaTitulosBase.empresaSelecionada = listaTitulosSelecionados[0].codigoEmpresa;
          baixaTitulosBase.passoAtivo = '1';
          storeTitulosFinanceiro = UtilitarioGeral.instanciaObjetoLocal(storeFinanceiro.getters.obterTituloFinanceiroStore(tokenStore));
          storeFinanceiro.mutations.removerTitulos(tokenStore);
        }

        comunicacaoFinanceiro = storeFinanceiro.getters.obterComunicacao(tokenStore);
        if (UtilitarioGeral.objetoValido(comunicacaoFinanceiro) && UtilitarioGeral.validaCodigo(comunicacaoFinanceiro.empresa)) {
          baixaTitulosBase.empresaSelecionada = comunicacaoFinanceiro.empresa;
        }
      }
      await obterPermissoes(ETipoPermissao.Autorizacoes);
      await preencherEmpresasDisponiveis();
      verificaAutorizacao(baixaTitulosBase.empresaSelecionada, telaBase.identificadorPermissao, true);
      await obterValoresParametros();
      baixaTitulosBase.contaPadrao = await servicoConta.obterCodigoContaPadrao(baixaTitulosBase.empresaSelecionada);
      baixaTitulosBase.dataBaixa = await servicoSistema.obterDataAtual();
      if (UtilitarioGeral.validaLista(listaTitulosSelecionados)) {
        popularTitulosBaixa(listaTitulosSelecionados);
      }
      const recebimentoNormal = { codigoConta: baixaTitulosBase.contaPadrao, dataBaixa: baixaTitulosBase.dataBaixa, valor: 0 } as IDTOLancamentoBaixaConta;
      baixaTitulosBase.lancamentosContaNormais.push(recebimentoNormal);
      telaBase.carregando = false;
    });

    async function verificarPassos() {
      if (baixaTitulosBase.passoAtivo === '7') {
        await prepararPreviaBaixa();
        if (baixaTitulosBase.movimentosInvalidos) {
          baixaTitulosBase.passoAtivo = '1';
        }
      }
    }
    function verificarConclusaoBaixa(): boolean {
      if (baixaTitulosBase.movimentosInvalidos) return false;

      if (!UtilitarioGeral.validaLista(baixaTitulosBase.movimentosFinanceiros)) {
        return false;
      }

      if (baixaTitulosBase.passoAtivo === '7') {
        if (baixaTitulosBase.totalSobraValores > 0 && (baixaTitulosBase.totalSobraValores === baixaTitulosBase.totalCreditosLancados)) {
          return true;
        }

        if (baixaTitulosBase.totalSobraValores === 0) {
          return true;
        }
      }

      return false;
    }

    function removerTodosTitulos() {
      baixaTitulosBase.titulosBaixa = [] as IDTOTituloFinanceiroPendenteBaixa[];
      calcularValores(false);
      prepararPreviaBaixa();
    }

    function removerTitulosMarcados() {
      gradeBase.codigosSelecionados.forEach((t) => {
        const indexTitulo = baixaTitulosBase.titulosBaixa.findIndex((ts) => ts.codigoTituloFinanceiro === t);
        baixaTitulosBase.titulosBaixa.splice(indexTitulo, 1);
      });
      gradeBase.codigosSelecionados = [];
      calcularValores(false);
      prepararPreviaBaixa();
      preencherPessoaPadrao();
    }

    return {
      baixaTitulosBase,
      props,
      modalBase,
      window,
      UtilitarioData,
      storeSistema,
      ETipoTituloFinanceiro,
      telaBase,
      gradeBase,
      atualizarValorRestante,
      ordenacaoAtiva,
      atualizarSelecaoEmpresas,
      adicionarAtalho,
      removerAtalho,
      buscarTitulos,
      concluirBaixa,
      removerTodosTitulos,
      popularTitulosBaixa,
      UtilitarioMascara,
      removerTitulosMarcados,
      calcularValores,
      ECustomRenderRow,
      obterDescricaoConta,
      obterDescricaoTipoMovimento,
      obterDescricaoInfluenciaSaldo,
      confirmacaoBaixa,
      confirmacaoLimparTela,
      UtilitarioFinanceiro,
      verificacaoCalculo,
      mudarSelecao,
      valorJurosMultaDigitado,
      valorAcrescimoDigitado,
      valorDescontoDigitado,
      verificarPassos,
      verificarConclusaoBaixa,
      verificacaoAlteracaoData,
      proximoElemento,
      elementoAnterior,
      elementoAcima,
      elementoAbaixo,
    };
  },
});
